import BarcodeScanner from '../components/BarcodeScanner/BarcodeScanner';

function Test() {

  return (
    <div className="test">
      <BarcodeScanner  />
    </div>
  );
}

export default Test;
